// extracted by mini-css-extract-plugin
export default {"wrapper":"NewMusicEveryDay_wrapper__GQTTE","title":"NewMusicEveryDay_title__s-Gpi","list":"NewMusicEveryDay_list__6IZw-"};